import { useContext, useEffect, useState } from 'react';
import '../css/user/edituser.css';
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { MdClose, MdModeEdit, MdContactPhone, MdAssignmentInd, MdVerifiedUser, MdPhotoCamera } from 'react-icons/md';
import api from '../../api';
import Swal from 'sweetalert2';
import { storage } from "../../firebase"; // Ensure storage is exported from your firebase.js
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { Datacontext } from '../../context/dataContext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

export const Edituser = ({ set_edit, id, showToast, userg }) => {
    const { setDim } = useContext(Dimcontext);
    const navigate = useNavigate();
    const { users } = useContext(Datacontext);

    // Image States
    const [imageFile, setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploading, setUploading] = useState(false);

    const [userd, setuserd] = useState({
        uid: '', 
        name: '', 
        mobile: '', 
        amobile: '',
        aadharno: '', 
        relname: '', 
        relmobile: '', 
        docdet: '', 
        email: '',
        role: '',
        profileImage: ''
    });

    const revokeIfBlobUrl = (url) => {
        if (typeof url !== "string") return;
        if (!url.startsWith("blob:")) return;
        URL.revokeObjectURL(url);
    };

    const handleRemovePhoto = () => {
        revokeIfBlobUrl(preview);
        setPreview(null);
        setImageFile(null);
        setuserd((prev) => ({ ...prev, profileImage: "" }));
    };

    const handleeditclose = () => {
        revokeIfBlobUrl(preview);
        set_edit(false);
        setDim(false);
    };

    

    useEffect(() => { 
        const getedit = (id) => {
        const d = users.find(item => item.id === id);
        if (d) {
            const initialData = {
                uid: d.uid || '',
                name: d.name || '',
                mobile: d.mobile?.toString() || '',
                amobile: d.amobile?.toString() || '',
                aadharno: d.aadharno?.toString() || '',
                relname: d.relname || '',
                relmobile: d.relmobile?.toString() || '',
                docdet: d.docdet || 'no',
                email: d.email || '',
                role: d.role || 'user',
                profileImage: d.profileImage || ''
            };
            setuserd(initialData);
            setPreview(d.profileImage || null);
        }
    };
        getedit(id); 
    }, [id, users]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            revokeIfBlobUrl(preview);
            setImageFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleRoleChange = (newRole) => {
        if (newRole === userd.role) return;

        Swal.fire({
            title: "Change User Role?",
            text: `Confirm promoting/demoting this user to ${newRole.toUpperCase()}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, change it!"
        }).then((result) => {
            if (result.isConfirmed) {
                setuserd({ ...userd, role: newRole });
            }
        });
    };

    const up = async (e) => {
        e.preventDefault();
        
        if (userd.mobile.length !== 10) return showToast("Primary mobile must be 10 digits");
        if (userd.aadharno.length !== 12) return showToast("Aadhar must be 12 digits");

        try {
            setUploading(true);
            let finalImageUrl = userd.profileImage;

            // 1. Upload new image if selected
            if (imageFile) {
                const storageRef = ref(storage, `user_profiles/${userd.uid}_${Date.now()}`);
                finalImageUrl = await new Promise((resolve, reject) => {
                    const uploadTask = uploadBytesResumable(storageRef, imageFile);
                    uploadTask.on(
                        "state_changed",
                        () => {
                            // optional: progress handler
                        },
                        (error) => reject(error),
                        async () => {
                            try {
                                const url = await getDownloadURL(uploadTask.snapshot.ref);
                                resolve(url);
                            } catch (e) {
                                reject(e);
                            }
                        },
                    );
                });
            }

            const data = { 
                ...userd,
                profileImage: finalImageUrl,
                relname: userd.relname.toLowerCase(),
                role: userd.role.toLowerCase(),
                name: userd.name.toLowerCase().trim(),
                email: userd.email.trim()
            };

            await api.put(`/edit_one_user/${id}`, data);
            
            Swal.fire({
                title: "Updated!",
                text: "User profile successfully modified.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            setUploading(false);
            handleeditclose();
            userg();
        } catch (err) { 
            setUploading(false);
            console.error(err);
            if (err.response?.status === 401) {
                showToast("Session expired. Logging out.");
                navigate("/");
            } else {
                showToast(err.response?.data?.message || "Something went wrong.");
            }
        }
    };

    return (
        <div className="edituser-card shadow-lg">
            <ToastContainer/>
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdModeEdit className="me-2" />
                    <span>Modify User Account</span>
                </div>
                <button onClick={handleeditclose} className="btn-close-custom"><MdClose /></button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(85vh - 70px)' }} noScrollX>
                <Form onSubmit={up} className="p-4">
                    
                    {/* Section: Profile Image */}
                    <div className="form-section text-center mb-4">
                        <h6 className="section-title text-start"><MdPhotoCamera className="me-2"/>Profile Photo</h6>
                        <div className="d-flex align-items-center gap-4 p-3 border rounded bg-light">
                            <div className="preview-container">
                                {preview ? (
                                    <img src={preview} alt="Profile" className="rounded-circle shadow" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                ) : (
                                    <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white shadow" style={{ width: '80px', height: '80px' }}>
                                        No Img
                                    </div>
                                )}
                            </div>
                            <div className="flex-grow-1 text-start">
                                <FormLabel className="small text-muted">Upload new photo to update</FormLabel>
                                <FormControl type="file" accept="image/*" onChange={handleFileChange} />
                                {preview ? (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 mt-2 text-danger"
                                        onClick={handleRemovePhoto}
                                        disabled={uploading}
                                        aria-label="Remove profile photo"
                                    >
                                        Remove Photo
                                    </button>
                                ) : null}
                                {uploading && <small className="text-primary d-block mt-1 animate-pulse">Processing cloud upload...</small>}
                            </div>
                        </div>
                    </div>

                    {/* Section: Identity Details */}
                    <div className="form-section">
                        <h6 className="section-title"><MdAssignmentInd className="me-2"/>Identity & System</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>User ID</FormLabel>
                                    <FormControl readOnly value={userd.uid} className="input-readonly" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel className="fw-bold">Account Role</FormLabel>
                                    <div className="role-selector-box d-flex align-items-center mt-1 border p-2 rounded bg-white">
                                        <Form.Check 
                                            inline label="User" type="radio" name="userRole" id="role-user"
                                            checked={userd.role === 'user'} 
                                            onChange={() => handleRoleChange('user')} 
                                        />
                                        <Form.Check 
                                            inline label="Admin" type="radio" name="userRole" id="role-admin"
                                            checked={userd.role === 'admin'} 
                                            onChange={() => handleRoleChange('admin')} 
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Full Name</FormLabel>
                                    <FormControl required value={userd.name} onChange={(e) => setuserd({ ...userd, name: e.target.value })} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Contact Details */}
                    <div className="form-section">
                        <h6 className="section-title"><MdContactPhone className="me-2"/>Contact Information</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Primary Mobile</FormLabel>
                                    <FormControl required maxLength={10} pattern="[0-9]{10}" value={userd.mobile} onChange={(e) => setuserd({ ...userd, mobile: e.target.value.replace(/\D/g, "") })} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Email Address</FormLabel>
                                    <FormControl required type="email" value={userd.email} onChange={(e) => setuserd({ ...userd, email: e.target.value })} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Name</FormLabel>
                                    <FormControl required value={userd.relname} onChange={(e) => setuserd({ ...userd, relname: e.target.value })} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Relative Mobile</FormLabel>
                                    <FormControl required maxLength={10} pattern="[0-9]{10}" value={userd.relmobile} onChange={(e) => setuserd({ ...userd, relmobile: e.target.value.replace(/\D/g, "") })} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Verification */}
                    <div className="form-section">
                        <h6 className="section-title"><MdVerifiedUser className="me-2"/>Verification Status</h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Aadhar Number</FormLabel>
                                    <FormControl required maxLength={12} pattern="[0-9]{12}" value={userd.aadharno} onChange={(e) => setuserd({ ...userd, aadharno: e.target.value.replace(/\D/g, "") })} />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <div className="doc-collect-box border p-3 rounded">
                                    <FormLabel className="me-4 fw-bold mb-0">Original Document Collected?</FormLabel>
                                    <Form.Check inline label="Yes" type="radio" checked={userd.docdet === 'yes'} onChange={() => setuserd({...userd, docdet: 'yes'})} />
                                    <Form.Check inline label="No" type="radio" checked={userd.docdet === 'no'} onChange={() => setuserd({...userd, docdet: 'no'})} />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions sticky-bottom bg-white p-3 border-top d-flex justify-content-end">
                        <Button variant="secondary" className="px-4 me-2" onClick={handleeditclose} disabled={uploading}>Cancel</Button>
                        <Button type='submit' className="btn-submit px-5" disabled={uploading}>
                            {uploading ? 'Updating...' : 'Update Changes'}
                        </Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    );
};